module.exports = __webpack_public_path__ + "img/secondary_6x2_z16.7a73fcd6.svg";